import { render, staticRenderFns } from "./MonthlyUsageTable.vue?vue&type=template&id=0f90fb38&"
import script from "./MonthlyUsageTable.vue?vue&type=script&lang=js&"
export * from "./MonthlyUsageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VLayout})
